import { render, staticRenderFns } from "./ModalDonationDetails.vue?vue&type=template&id=493a8a34&scoped=true"
import script from "./ModalDonationDetails.vue?vue&type=script&lang=js"
export * from "./ModalDonationDetails.vue?vue&type=script&lang=js"
import style0 from "./ModalDonationDetails.vue?vue&type=style&index=0&id=493a8a34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "493a8a34",
  null
  
)

export default component.exports